import React from 'react';
import PropTypes from 'prop-types';

export default function SearchSVG(props) {
  const {styles} = props;
  return (
    <svg 
      width={styles.width || '32px'}
      height={styles.height || '32px'}
      className={props.className || ''}
      id={props.id || ''}
      viewBox="0 0 32 32" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg">
      <g 
        id="Icons" 
        troke="none" 
        strokeWidth="1" 
        fill="none" 
        fillRule="evenodd">
        <g 
          d="Icon/Search" 
          fill={styles.fill || "#000"}>
          <path 
            d="M23.524618,20.3440135 C27.2190153,15.3794266 26.7843803,8.25632378 22.2207131,3.72344013 C17.2224109,-1.24114671 8.96434635,-1.24114671 3.74872666,3.72344013 C-1.24957555,8.68802698 -1.24957555,16.8903879 3.74872666,22.0708263 C6.3565365,24.6610455 9.61629881,25.9561551 12.8760611,25.9561551 C15.483871,25.9561551 18.0916808,25.0927487 20.4821732,23.5817875 L28.9575552,32 L32,28.762226 L23.524618,20.3440135 Z M7.00848896,6.96121417 C8.74702886,5.23440135 10.9202037,4.37099494 13.0933786,4.37099494 C15.2665535,4.37099494 17.4397284,5.23440135 19.1782683,6.96121417 C22.655348,10.4148398 22.655348,15.8111298 19.1782683,19.0489039 C15.7011885,22.5025295 10.2682513,22.5025295 7.00848896,19.0489039 C3.53140917,15.5952782 3.53140917,10.1989882 7.00848896,6.96121417 Z" 
            id="Shape">
          </path>
        </g>
      </g>
    </svg>
  );
}


SearchSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

SearchSVG.defaultProps = {
  className: '',
  id: '',
  styles: {
    fill: "#000",
    height: '32px',
    width: '32px'
  }
};
  
